export default "__VITE_ASSET__CdJhZ$77__"